import React from "react";
import { ContactSection, ContactCard } from "@/.storyblok/types/319751/storyblok-components";
import Image from "next/image";
import Link from "next/link";
import { storyblokEditable, SbBlokData } from "@storyblok/react";

interface ContactSectionProps {
  blok?: ContactSection & SbBlokData & {
    contact_cards?: ContactCard[];
  };
}

const ContactSectionComponent: React.FC<ContactSectionProps> = ({ blok }) => {
  if (!blok) return null;

  const { title, description, contact_cards } = blok;

  const renderContactCard = (card: ContactCard) => {
    const { icon, title, content_type, value, _uid } = card;

    const renderContent = () => {
      switch (content_type) {
        case "phone":
          return (
            <p>
              Simply give us a call at:<br />
              <Link
                href={`tel:${value}`}
                className="highlight-text"
                style={{ textDecoration: "underline" }}
              >
                {value}
              </Link>
            </p>
          );
        case "email":
          return (
            <p>
              Send us an email directly to:<br />
              <Link
                href={`mailto:${value}`}
                className="highlight-text"
                style={{ textDecoration: "underline" }}
              >
                {value}
              </Link>
            </p>
          );
        case "address":
          return (
            <p>
              {value}
            </p>
          );
        case "reg_address":
          return (
            <p>
              <Link
                href={`mailto:${value}`}
                className="highlight-text"
                style={{ textDecoration: "underline" }}
              >
                Book to come and see us:
              </Link>
              <br />
              Target Defense, 300 S Orange Ave # 1000, Orlando, FL 32801
            </p>
          );
        default:
          return null;
      }
    };

    return (
      <div className="one-quarter margin-bottom-mobile text-center" key={_uid}>
        {icon?.filename && (
          <Image
            src={icon.filename}
            alt={icon.alt || title || ""}
            width={70}
            height={70}
            className="margin-bottom-small"
            sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
            loading="lazy"
            quality={75}
          />
        )}
        {title && <h4>{title}</h4>}
        {renderContent()}
      </div>
    );
  };

  return (
    <div {...storyblokEditable(blok)} className="container">
      <div className="padding-medium text-center">
        <div className="full-width margin-bottom-medium">
          {title && <h2>{title}</h2>}
          {description && <p>{description}</p>}
        </div>
        {contact_cards && contact_cards.length > 0 && (
          <div className="full-width margin-bottom-medium">
            {contact_cards.map(renderContactCard)}
          </div>
        )}
      </div>
    </div>
  );
};

export default ContactSectionComponent;